import { GoogleLogin } from '@react-oauth/google';
import {
  useToast,
  Box
} from '@chakra-ui/react';
import { FaGoogle } from 'react-icons/fa';

const GoogleAuthButton = ({
  onSuccess,
  onError,
  buttonText = "continue_with",
  isLoading = false
}) => {
  const toast = useToast();

  const handleSuccess = (credentialResponse) => {
    if (onSuccess) {
      onSuccess(credentialResponse);
    }
  };

  const handleError = (error) => {
    console.error('Google OAuth Error:', error);
    toast({
      title: 'Google Sign-In Failed',
      description: 'Please try again or use manual registration',
      status: 'error',
      duration: 3000,
      isClosable: true,
    });
    if (onError) {
      onError(error);
    }
  };

  return (
    <Box
      width="48px"
      height="48px"
      overflow="hidden"
      position="relative"
      sx={{
        WebkitBoxReflect: 'none !important',
        WebkitAppearance: 'none !important',
        overflow: 'hidden !important',
        '&::before, &::after': {
          display: 'none !important'
        },
        '& *': {
          WebkitBoxReflect: 'none !important',
          WebkitAppearance: 'none !important',
        },
        '& div[role="button"]': {
          width: '48px !important',
          height: '48px !important',
          borderRadius: '8px !important',
          border: '1px solid #dadce0 !important',
          backgroundColor: 'white !important',
          display: 'flex !important',
          alignItems: 'center !important',
          justifyContent: 'center !important',
          padding: '0 !important',
          WebkitBoxReflect: 'none !important',
          WebkitAppearance: 'none !important',
          boxShadow: 'none !important',
          overflow: 'hidden !important',
          '&:hover': {
            backgroundColor: '#f8f9fa !important',
            borderColor: '#4285F4 !important'
          },
          '&::before, &::after': {
            display: 'none !important'
          }
        },
        '& div[role="button"] > div': {
          display: 'flex !important',
          alignItems: 'center !important',
          justifyContent: 'center !important',
          width: '100% !important',
          height: '100% !important',
          WebkitBoxReflect: 'none !important',
        },
        '& iframe': {
          width: '48px !important',
          height: '48px !important',
          WebkitBoxReflect: 'none !important',
          WebkitAppearance: 'none !important',
          overflow: 'hidden !important',
        },
        '& svg': {
          width: '20px !important',
          height: '20px !important',
          margin: '0 auto !important',
          display: 'block !important',
          WebkitBoxReflect: 'none !important'
        },
        '& img': {
          WebkitBoxReflect: 'none !important',
          WebkitAppearance: 'none !important'
        },
        '& span': {
          display: 'none !important'
        },
        '& div[data-container-width]': {
          minWidth: '48px !important',
          width: '48px !important',
          WebkitBoxReflect: 'none !important',
        }
      }}
    >
      <GoogleLogin
        onSuccess={handleSuccess}
        onError={handleError}
        theme="outline"
        size="medium"
        useOneTap={false}
        auto_select={false}
        cancel_on_tap_outside={true}
        width="48"
        logo_alignment="center"
        shape="rectangular"
      />
    </Box>
  );
};

export default GoogleAuthButton;